module.exports = __webpack_public_path__ + "img/me.09465a6e.svg";